module.exports = __webpack_public_path__ + "img/shops-0.bbf1b39b.jpg";